import React, { Component } from 'react';
import LinkTab from '../../../../common/tab/TabNav.js';
import MainTable from '../../../../common/table/MainTable';
import * as columns from './AvailableDividendColumns';
import NewAvailableDividend from './NewAvailableDividend';

const tabs = [
    {
        path: "/availabledividend",
        className: "availabledividend",
        label: "Éves osztalék"
    },
    {
        path: "/dividend",
        className: "dividend",
        label: "Osztalék"
    }
];

class AvailableDividend extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "AVAILABLE_DIVIDEND";
            return item;
        })
        return data;
    }

    render() {
        return (<>
            <LinkTab tabs={tabs} index={0} />
            <MainTable
                divClassName="availabledividend"
                tableName="Éves osztalékok"
                newObjectLabel="Új éves osztalék hozzáadása"
                path='/api/availabledividends'
                enrich={this.enrich}
                columns={(props) => columns.columns(props)}
                dialogContent={(refresh, close) => <NewAvailableDividend refresh={refresh} close={close} />} />
        </>
        );
    }
}

export default AvailableDividend;